import { lit, int, end } from "fp-ts-routing"

const Projects = lit("projects").then(int("projectId"))
const Scenarios = Projects.then(lit("scenarios"))
const TestPlans = Projects.then(lit("test_plans"))
const Results = Projects.then(lit("results"))
const Admins = lit("admin")
const Partner = lit("partner")
const Settings = lit("settings")
const ProjectSettings = Settings.then(lit("projects")).then(int("projectId"))

export const ProjectSettingsList = ProjectSettings.then(end)

export const ScenarioList = Scenarios.then(end)
export const ScenarioEditor = Scenarios.then(int("scenarioId")).then(end)
export const ScenarioHistory = Scenarios.then(int("scenarioId"))
  .then(lit("histories"))
  .then(int("historyId"))
  .then(end)
export const CompareScenarioHistory = Scenarios.then(int("scenarioId"))
  .then(lit("histories"))
  .then(int("historyId"))
  .then(lit("compare"))
  .then(int("compareId"))
  .then(end)
export const StepGroupList = Projects.then(lit("step_groups")).then(end)
export const StepGroupEditor = Projects.then(lit("step_groups"))
  .then(int("stepGroupId"))
  .then(end)
export const TestPlanList = TestPlans.then(end)
export const TestPlan = TestPlans.then(int("testPlanId")).then(end)
export const TestPlanScenarioList = TestPlans.then(int("testPlanId"))
  .then(lit("edit"))
  .then(end)
export const TestPlanCapabilityResult = Results.then(int("resultId"))
  .then(lit("capabilities"))
  .then(int("capabilityId"))
  .then(end)
export const TestCaseResults = Results.then(int("resultId"))
  .then(lit("capabilities"))
  .then(int("capabilityId"))
  .then(lit("scenarios"))
  .then(int("scenarioId"))
  .then(end)
export const UserSettings = Settings.then(lit("users"))
  .then(int("userId"))
  .then(end)
export const NewCustomActionForm = Settings.then(lit("projects"))
  .then(int("projectId"))
  .then(lit("custom_actions"))
  .then(lit("new"))
  .then(end)
export const EditCustomActionForm = Settings.then(lit("projects"))
  .then(int("projectId"))
  .then(lit("custom_actions"))
  .then(int("customActionId"))
  .then(lit("edit"))
  .then(end)
export const CustomActionDependents = ProjectSettings.then(
  lit("custom_actions")
)
  .then(int("customActionId"))
  .then(lit("dependents"))
  .then(end)
export const CapabilityForm = TestPlans.then(int("testPlanId"))
  .then(lit("capabilities"))
  .then(lit("new"))
  .then(end)
export const CapabilityFormRetry = TestPlans.then(int("testPlanId"))
  .then(lit("capabilities"))
  .then(end)
export const GotthardKeyNewForm = ProjectSettings.then(lit("access_points"))
  .then(lit("new"))
  .then(end)
export const GotthardKeyEditForm = ProjectSettings.then(lit("access_points"))
  .then(int("gotthardKeyId"))
  .then(end)
export const NewAdminSsoConfirmationForm = Admins.then(lit("organizations"))
  .then(int("organizationId"))
  .then(lit("sso_configurations"))
  .then(lit("new"))
  .then(end)
export const EditAdminSsoConfigurationForm = Admins.then(
  lit("sso_configurations")
)
  .then(int("ssoConfigurationId"))
  .then(lit("edit"))
  .then(end)
export const DestroyAdminSsoConfigurationForm = Admins.then(
  lit("sso_configurations")
)
  .then(int("ssoConfigurationId"))
  .then(lit("confirm_destroy"))
  .then(end)
export const NewAdminCustomActionForm = Admins.then(lit("custom_actions"))
  .then(lit("new"))
  .then(end)
export const AdminCustomActionReader = Admins.then(lit("custom_actions"))
  .then(int("customActionId"))
  .then(end)
export const EditAdminCustomActionForm = Admins.then(lit("custom_actions"))
  .then(int("customActionId"))
  .then(lit("edit"))
  .then(end)
export const AdminScenarioTransfers = Admins.then(
  lit("scenario_transfers")
).then(end)
export const AdminPartnerList = Admins.then(lit("partners")).then(end)
export const AdminPartnerDetail = Admins.then(lit("partners"))
  .then(int("partnerId"))
  .then(end)

export const PartnerRoot = Partner.then(end)
export const PartnerScenarioTransfers = Partner.then(
  lit("scenario_transfers")
).then(end)
export const PartnerOrganizations = Partner.then(lit("organizations")).then(end)
export const PartnerProjects = Partner.then(lit("organizations"))
  .then(int("organizationId"))
  .then(end)

export const TriggerEditor = TestPlans.then(int("testPlanId"))
  .then(lit("triggers"))
  .then(end)
const TrialFormBase = lit("trial")

export const TrialForm = TrialFormBase.then(end)
export const TrialFormSettings = TrialFormBase.then(lit("settings")).then(end)
export const TrialFormUsage = TrialFormBase.then(lit("usage")).then(end)

export const TestPlanResultList = Projects.then(lit("results")).then(end)
export const Reports = Projects.then(lit("reports"))

export const AutifyUsageReport = Reports.then(lit("autify_usage")).then(end)
export const CreditUsageReport = Reports.then(lit("credit_usage")).then(end)
export const Project = Projects.then(end)
export const DomSnapshot = lit("dom_snapshot").then(end)
export const Graphiql = lit("graphiql").then(end)
